import React, { useState, useEffect } from "react";
import {request} from 'utils.js'
import { Button, Form, Input, Space,Modal } from 'antd';
import "./index.less";
import checkbookbg from "static/img/checkbookbg.jpg";

export default function BookCheck(props) {
	const [form] = Form.useForm();
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [searchBook, setSearchBook] = useState({});
	const [searchCon, setSearchCon] = useState({});
	const  onFinish = (values) => {
		setSearchCon(values)
		
	};
	const onReset = () => {
		form.resetFields();
	};
	const handleCancel = () => {
		setIsModalOpen(false);
	};
	useEffect(() => {
		
		if(searchCon.code){
			request({
				method: "post",
				url: '/aiprt-calibrate-center-be/biddernotice/checkNotice',
				data: {
					"code" : searchCon.code,
					"checkNum" : searchCon.checkNum,
				},
			}).then((res) => {
				setSearchBook(res);
				setIsModalOpen(true)
			});
		}
	}, [searchCon]);
	
	return (
		<>
			<div className="bookCheck-bg">
				<div className="bookCheck-img"><img src={checkbookbg} /></div>
				<div className="bookCheck-con">
					<Form
						form={form}
						name="control-hooks"
						onFinish={onFinish}
					>
						<Form.Item name="code" 
							rules={[
								{ required: true, message:'请输入中标通知书编号', },
								// { pattern:/^[a-zA-Z0-9]{14,15}$/, message:"请输入15位正确中标通知书编号", }
							]}
						>
							<Input placeholder="请输入中标通知书编号" />
						</Form.Item>
						<Form.Item name="checkNum" 
							rules={[
								{ required: true,message:'请输入通知书验证码', },
								{ pattern:/^\d{4,4}$/, message:"请输入正确四位数验证码", }
							]}
						>
							<Input placeholder="请输入通知书验证码" />
						</Form.Item>
						<Form.Item >
						<div className="bookCheck-tool">
							<Button type="primary" htmlType="submit" >
								查询
							</Button>
							<Button htmlType="button" onClick={onReset}>
								重置
							</Button>
						</div>
						</Form.Item>
					</Form>
				</div>
			</div>
			<Modal 
				title="中标通知书查询结果" 
				width='800px' 
				open={isModalOpen} 
				onCancel={handleCancel}
				footer={[
					<Button key="back" onClick={handleCancel}>
					  关闭
					</Button>,
				 ]}
			>
				<ul className="bookCheckList">
					<li>
						<label>项目名称：</label><span>
							{searchBook.projectName}
						</span>
					</li>
					<li>
						<label>项目编号：</label><span>
							{searchBook.projectCode}
						</span>
					</li>
					<li>
						<label>采购单位：</label><span>
							{searchBook.tenderOrg || '无'}
						</span>
					</li>
					<li>
						<label>采购实施机构：</label><span>
							{searchBook.tenderInstitution}
						</span>
					</li>
					<li>
						<label>中标单位：</label><span>
							{searchBook.bidder}
						</span>
					</li>
					<li>
						<label>中标金额：</label><span>
							{searchBook.bidAmount}
						</span>
					</li>
				</ul>
			</Modal>
	 	</>
	);
}
